// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import MenuMobile from './MenuMobile'
import { inject, observer } from 'mobx-react'
import { StoreContext } from '../contexts/StoreContext'
import LoadingSpinner from '../components/common/LoadingSpinner'
import styled from 'styled-components'

import { useStores } from 'hooks/useStores'

import { CONSTANTS } from '../utils/constants'
import { getTenantInfo } from 'utils/utils'

const LoadingSpinnerContainer = styled.div`
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
`

const MenuDesktop = inject(
	'User',
	'Infra'
)(
	observer((props) => {
		const { User, Infra } = props

		const { store } = useContext(StoreContext)
		const { addressManagerV2Store } = useStores()

		const [isMenuReady, setIsMenuReady] = useState(false)

		useEffect(() => {
			const newUrl = window.location.search
			const tenantId = getTenantInfo()
			if (!newUrl.includes(`showMenu_${tenantId}`) && !newUrl.includes(`j=${tenantId}`)) {
				addressManagerV2Store.storeMenuUrlToLS(newUrl)
			}
		}, [])

		useEffect(() => {
			if (store?.data) {
				setIsMenuReady(true)
			}
		}, [store?.data])

		if (!isMenuReady) {
			return (
				<LoadingSpinnerContainer>
					<LoadingSpinner chainId={Infra.appParams?.c} brand={Infra.appParams.brand} />
				</LoadingSpinnerContainer>
			)
		}

		return (
			<Grid container direction="row">
				<Grid item sm={9} md={9} lg={9} xl={9}>
					<MenuMobile
						showSideMenu={
							[
								CONSTANTS.APP.TYPES.WEB,
								CONSTANTS.APP.TYPES.WEB_MOBILE,
								CONSTANTS.APP.TYPES.ANDROID_APP,
								CONSTANTS.APP.TYPES.IOS_APP,
							].includes(User.session.appid) || Infra.appParams?.eCommerce
						}
					/>
				</Grid>
				<Grid item sm={3} md={3} lg={3} xl={3} />
			</Grid>
		)
	})
)

export default MenuDesktop
